import { tenantSiteUrl } from './tenant-url'
import type { InitData } from './widget-base'

/**
 * Studiets handelsbetingelser og privatlivspolitik, som gæste-købets samtykke
 * linker til (samme sider som den native booking-modal).
 *
 * ⚠️ Spejl af `LEGAL_DOCUMENT_PATHS` i apps/holdstyring/src/lib/legal-document-paths.ts.
 * Widget-bundlen kan ikke importere app-koden, så tabellen står her igen. En
 * jest-test (widget-guest-checkout) holder de to ens, så de ikke kan glide fra
 * hinanden.
 */
export const WIDGET_LEGAL_PATHS = {
  da: { privacy: '/privatlivspolitik', terms: '/handelsbetingelser1', withdrawal: '/fortrydelsesret' },
  en: { privacy: '/privacy-policy', terms: '/terms-and-conditions', withdrawal: '/withdrawal-policy' },
} as const

/** Dansk og norsk (og ukendt) bruger de danske adresser, alle andre de engelske. */
export function legalPathSet(locale: string | null | undefined): 'da' | 'en' {
  return locale === 'da' || locale === 'nb' || !locale ? 'da' : 'en'
}

export function legalDocumentUrl(
  initData: Pick<InitData, 'tenantSlug' | 'customDomain' | 'locale'>,
  doc: 'privacy' | 'terms' | 'withdrawal',
): string {
  return `${tenantSiteUrl(initData)}${WIDGET_LEGAL_PATHS[legalPathSet(initData.locale)][doc]}`
}

/** «Fortryd aftale» på studiets eget site (jura-hs T7/p44). */
export function withdrawContractUrl(initData: Pick<InitData, 'tenantSlug' | 'customDomain' | 'locale'>): string {
  return `${tenantSiteUrl(initData)}/fortryd`
}
